<template>
  <div id="LeaveRequests">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">درخواست مرخصی</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container">
          <div class="row" id="LeaveRequestsForm">
            <div class="mb-3">
              <a v-if="Add == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="Add = 1" title="درخواست جدید">
                <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
              </a>
              <a
                v-if="Add != 0"
                class="d-inline float-right mx-2 mt-1"
                href="javascript:;"
                @click="
                  Add = 0
                  ResetForm()
                "
                title="لغو افزودن"
              >
                <h4><i class="fas fa-times text-danger"></i></h4>
              </a>
            </div>
            <div class="col-12" v-if="Add != 0">
              <user-info-header></user-info-header>
              <div class="row" >
                <div class="col-md-8 col-12">
                  <div class="row mt-5">
                    <div class="row w-100">
                      <div class="col-md-4 col-12">
                        <div class="mt-2">
                          <small id="LblName"> نوع درخواست : </small>
                          <SearchableCombo
                            :edit="false"
                            :grp="102"
                            :code="null"
                            @ResultCombo="GetResulGrp102"
                            :rownumintable="3"
                            :defaultvalue="DataAxios.tblCombogrp102NoeDarkhast"
                            :action="'TblCrmCombo/GetComboById'"
                            :method="'POST'"
                            :idinput="'Grp102'"
                            :keyItem="'Grp102'"
                            :ClassProps="'required'"
                          >
                          </SearchableCombo>
                        </div>
                      </div>
                      <div class="col-md-4 col-12">
                        <div class="mt-2">
                          <small id="LblName"> نوع مرخصی : </small>
                          <SearchableCombo
                            :edit="false"
                            :grp="103"
                            :code="null"
                            @ResultCombo="GetResulGrp103"
                            :rownumintable="3"
                            :defaultvalue="DataAxios.tblcombogrp103NoeMorakhasi"
                            :action="'TblCrmCombo/GetComboById'"
                            :method="'POST'"
                            :idinput="'Grp103'"
                            :keyItem="'Grp103'"
                            :ClassProps="'required'"
                          >
                          </SearchableCombo>
                        </div>
                      </div>
                    </div>
                    <div class="row w-100">
                      <div class="col-md-3 col-12">
                        <div class="mt-2">
                          <small id="LbltarixAz" v-if="isRoozane"> از تاریخ : </small>
                          <small id="LbltarixAz" v-if="isSaati"> تاریخ : </small>
                          <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.tarixAz" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
                        </div>
                      </div>
                      <div class="col-md-3 col-12" v-if="isSaati">
                        <div class="mt-2" :key="RenderEditForm">
                          <small id="LbltarixAz"> از ساعت : </small>
                          <date-picker color="dimgray" type="time" input-class="required form-control" id="StartTime" v-model="DataAxios.StartTime" clearable :editable="true" placeholder=" از ساعت "></date-picker>
                        </div>
                      </div>

                      <div class="col-md-3 col-12" v-if="isRoozane">
                        <div class="mt-2">
                          <small id="LbltarixTa"> تا تاریخ : </small>
                          <date-picker :min="DataAxios.tarixAz" color="dimgray" input-class="required form-control" v-model="DataAxios.tarixTa" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
                        </div>
                      </div>
                      <div class="col-md-3 col-12" v-if="isSaati">
                        <div class="mt-2">
                          <small id="LbltarixTa"> تا ساعت : </small>
                          <date-picker color="dimgray" input-class="required form-control" type="time" id="EndTime" v-model="DataAxios.EndTime" clearable :editable="true" placeholder=" تا ساعت "></date-picker>
                        </div>
                      </div>

                      <div class="col-md-2 col-12" v-if="isRoozane">
                        <div class="mt-2">
                          <!-- <i class="fad fa-calendar-week"></i> -->
                          <small id="LblName"> به مدت : </small>
                          <input type="number" class="form-control text-center required" placeholder="روز" v-model="DataAxios.countDate" @keypress="$ValidNumber($event, 1, true)" />
                          <!-- <small class="text-warning font-weight-bold"> {{ $CalcDayBetween2Date(DataAxios.tarixAz, DataAxios.tarixTa) }}</small>
                          <small v-if="isRoozane"> روز </small> -->
                        </div>
                      </div>

                      <div class="col-md-3 col-12" v-if="DataAxios.StartTime != '' && DataAxios.EndTime != '' && isSaati">
                        <div class="mt-5">
                          <i class="fad fa-datetime" style="color: var(--logo-color) !important"></i>
                          <small id="LblName"> به مدت : </small>
                          <small class="text-warning font-weight-bold">{{ $SubtractTime(DataAxios.StartTime, DataAxios.EndTime) }}</small>
                          <small v-if="isSaati">ساعت</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-12">
                  <div class="row mt-5">
                    <small>بارگذاری مدارک</small>
                    <uploader @upload="GetFile"></uploader>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-9"></div>
                <div class="col-2">
                  <button v-if="Add == 1" class="btn btn-success mt-4 text-center w-100" @click="SetLeave">ثبت مرخصی</button>
                  <button v-if="Add == -1" class="btn btn-warning mt-4 text-center w-100" @click="Edit">ویرایش مرخصی</button>
                </div>
                <div class="col-1"></div>
              </div>
            </div>

            <div class="col-12" v-else>
              <div class="row mt-2">
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblName"> نوع درخواست : </small>
                    <!-- <SearchableCombo :edit="false" :grp="102" :code="null" @ResultCombo="GetResulGrp102Filter" :rownumintable="3" :defaultvalue="Filter.tblCombogrp102NoeDarkhast" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Grp102'" :keyItem="'Grp102'" :ClassProps="'required'"></SearchableCombo> -->
                    <select class="form-control" v-model="Filter.tblCombogrp102NoeDarkhast">
                      <option v-for="(item, key) in ListGrp102NoeDarkhast" :key="key" :value="item.id">{{ item.name }}</option>
                      <option :value="null">همـــه</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblName"> نوع مرخصی : </small>
                    <!-- <SearchableCombo :edit="false" :grp="103" :code="null" @ResultCombo="GetResulGrp103Filter" :rownumintable="3" :defaultvalue="Filter.tblcombogrp103NoeMorakhasi" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Grp103'" :keyItem="'Grp103'" :ClassProps="'required'"></SearchableCombo> -->
                    <select class="form-control" v-model="Filter.tblcombogrp103NoeMorakhasi">
                      <option :value="item.id" :key="key" v-for="(item, key) in ListGrp103NoeMorakhasi">{{ item.name }}</option>
                      <option :value="null">همـــه</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-12 mt-2">
                  <small>از تاریخ </small>
                  <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixAz" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
                </div>
                <div class="col-md-2 col-12 mt-2">
                  <small>تا تاریخ </small>
                  <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixTa" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
                </div>
                <div class="col-md-2 col-12 mt-4">
                  <button type="button" class="btn btn-success w-100 mt-1" @click="GetListLeave"><i class="fad fa-search mt-1 ml-2"></i> اعمال فیلتر</button>
                </div>
              </div>
              <bnp-grid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true" :ShowDetail="true">
                <template slot="action-slot" slot-scope="props">
                  <request-info :RequestRow="props.props" :ApiAction="'LeaveRequests'" @Success="RefreshGrid" @DataEdit="DataEdit" :IsDelete="true" :IsEdit="true" :FormAutomation="ControlName"></request-info>
                </template>
                <template slot="filePath" slot-scope="props">
                  <a download="props.props.id" v-if="props.props.filePath != null" :href="$cookies.get('URL') + props.props.filePath"> <i class="fad fa-download"></i></a>
                </template>
                <template slot="startTime" slot-scope="props">
                  <span v-if="props.props.startTime == 'null'"> </span>
                </template>
                <template slot="endTime" slot-scope="props">
                  <span v-if="props.props.endTime == 'null'"> </span>
                </template>
                <template slot="calcDateTime" slot-scope="props">
                  <span v-if="props.props.tblCombogrp102NoeDarkhast == 1085235">{{ props.props.countDate }} روز</span>
                </template>
                <template slot="tarixTa" slot-scope="props">
                  <span v-if="props.props.tarixTa == 'null'"></span>
                  <span v-else>{{ props.props.tarixTa }}</span>
                </template>
                <template slot="Detail">
                  <!-- <div class="Detail mt-3 p-2">
                    <span>میزان مرخصی دریافتی شما بر اساس فیلتر جستجو </span>
                    <span class="text-danger"> {{ GetCountLeveReq() }} </span>
                    <span> می باشد </span>
                    <span></span>
                  </div>  -->
                  <div class="Detail mt-3 p-2">
                    <span>میزان مرخصی دریافتی شما بر اساس فیلتر جستجو </span>
                    <span class="text-danger"> {{ GetFullTimeRequest(Rows) }} </span>
                    <span> می باشد </span>
                    <span></span>
                  </div>
                </template>
              </bnp-grid>
            </div>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import UserInfoHeader from '@/components/AutomAtion/UserInfoHeader.vue'
import Uploader from '@/components/Uploader/Uploader.vue'
import RequestInfo from '@/components/AutomAtion/RequestInfo.vue'
import moment from 'moment-jalaali'
export default {
  data() {
    return {
      RenderEditForm:0,
      Flag: false,
      Add: 0,
      tarixTa: null,
      tarixAz: null,
      timeAz: null,
      timeTa: null,
      //   DataAxios: {},
      isRoozane: true,
      isSaati: false,
      DataAxios: { tblCombogrp102NoeDarkhast: 1085235, tblcombogrp103NoeMorakhasi: 1085237, StartTime: '', EndTime: '', Filepath: null, countDate: 1, tarixTa: '', tarixAz: '' },
      Rows: [],
      Column: [
        {
          name: 'noeDarkhast',
          label: 'نوع درخواست',
          visibility: true,
        },
        {
          name: 'noeMorkhasi',
          label: 'نوع مرخصی',
          visibility: true,
        },
        {
          name: 'tarixAz',
          label: 'از تاریخ ',
          visibility: true,
        },
        {
          name: 'tarixTa',
          label: 'تا تاریخ ',
          visibility: true,
        },
        {
          name: 'startTime',
          label: 'از ساعت ',
          visibility: true,
        },
        {
          name: 'endTime',
          label: 'تا ساعت ',
          visibility: true,
        },
        {
          name: 'calcDateTime',
          label: 'میزان مرخصی',
          visibility: true,
        },
        {
          name: 'filePath',
          label: 'پیوست',
          visibility: true,
        },
      ],
      File: null,
      Filter: { tblCombogrp102NoeDarkhast: null, tblcombogrp103NoeMorakhasi: null, tarixTa: '', tarixAz: '' },
      ListGrp102NoeDarkhast: [],
      ListGrp103NoeMorakhasi: [],
      ControlName:""
    }
  },
  components: {
    Card,
    datePicker: VuePersianDatetimePicker,
    SearchableCombo,
    BnpGrid,
    UserInfoHeader,
    Uploader,
    RequestInfo,
  },
  methods: {
    GetResulGrp102(data) {
      if (data.id != null) {
        if (this.rowForEdit) {
        }
        if (this.Flag == true) {
          this.Flag = false
          if (data.id == 1085235) {
            this.isRoozane = true
            this.isSaati = false
          } else {
            this.isSaati = true
            this.isRoozane = false
          }
          this.RenderEditForm++
        } else {
          this.DataAxios.tblCombogrp102NoeDarkhast = data.id
          if (data.id == 1085235) {
            this.isRoozane = true
            this.isSaati = false
            this.DataAxios.StartTime = ''
            this.DataAxios.EndTime = ''
            this.DataAxios.tarixAz = this.$GetJalaliDate()
            this.DataAxios.tarixTa = this.$GetJalaliDate()
          } else {
            this.isSaati = true
            this.isRoozane = false
            this.DataAxios.StartTime = this.$GetJalaliDateTime().substr(11)
            this.DataAxios.EndTime = ''
            this.DataAxios.tarixAz = this.$GetJalaliDate()
            this.DataAxios.tarixTa = this.$GetJalaliDate()
          }
        }
      }
    },
    GetResulGrp103(data) {
      if (data.id != null) {
        this.DataAxios.tblcombogrp103NoeMorakhasi = data.id
      }
    },
    SetLeave() {
      if (this.$ValidForm('LeaveRequestsForm')) {
        var SendData = { Action: 'LeaveRequests/SetLeaveRequests', Method: 'POST', ArryfildValue: null }
        var formData = new FormData()
        for (var key in this.DataAxios) {
          if (this.DataAxios[key] == null || this.DataAxios[key] == '') {
            formData.append(key, null)
          } else {
            // if (key == 'countDate') {
            //   this.DataAxios[key] = this.$CalcDayBetween2Date(this.DataAxios.tarixAz, this.DataAxios.tarixTa)
            // }
            formData.append(key, this.DataAxios[key])
          }
        }
        formData.append('file', this.File)
        SendData.ArryfildValue = formData
        this.$PostFormData(SendData).then((result) => {
          if (result.status == 'Ok') {
            this.$toasted.success('درخواست مرخصی با موفقیت ارسال گردید', { duration: 2000 })
            this.Add = 0
            this.GetListLeave()
            this.ResetForm()
          }
        })
      }
    },
    Edit() {
      if (this.$ValidForm('LeaveRequestsForm')) {
        var SendData = { Action: 'LeaveRequests/EditLeaveRequests', Method: 'POST', ArryfildValue: null }
        var formData = new FormData()
        for (var key in this.DataAxios) {
          if (this.DataAxios[key] == null || this.DataAxios[key] == '') {
            formData.append(key, null)
          } else {
            formData.append(key, this.DataAxios[key])
          }
        }
        formData.append('file', this.File)
        SendData.ArryfildValue = formData
        this.$PostFormData(SendData).then((result) => {
          if (result.status == 'Ok') {
            // this.$SetLog(this.DataAxios, 0, 0)
            this.$toasted.success('درخواست مرخصی با موفقیت اصلاح گردید', { duration: 2000 })
            this.Add = 0
            this.GetListLeave()
            this.ResetForm()
          }
        })
      }
    },
    GetListLeave() {
      let DataAxios_SetData = {
        ArryfildValue: this.Filter,
        Method: 'post',
        Action: 'LeaveRequests/Index',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.Rows = data.data
            this.Rows.forEach((el) => {
              // let Temp = el.tblcombogrp103NoeMorakhasi == 1085239 ? ' ساعت ' : el.tblcombogrp103NoeMorakhasi != 1085239 ? ' روز ' : ''
              el['calcDateTime'] = this.$SubtractTime(el.startTime, el.endTime) + ' ساعت '
            })
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetFile(data) {
      this.File = data
    },
    ResetForm() {
      this.DataAxios = { tblCombogrp102NoeDarkhast: null, tblcombogrp103NoeMorakhasi: null, StartTime: '', EndTime: '', Filepath: null, countDate: 1, tarixTa: '', tarixAz: '' }
      this.DataAxios.tarixAz = this.$GetJalaliDate()
      this.DataAxios.tarixTa = this.$GetJalaliDate()
    },
    RefreshGrid() {
      this.GetListLeave()
    },
    DataEdit(val) {
      this.$store.state.OldDataForLog = JSON.stringify(val)
      this.Add = -1
      this.DataAxios = { Id: val.id, tblCombogrp102NoeDarkhast: val.tblCombogrp102NoeDarkhast, tblcombogrp103NoeMorakhasi: val.tblcombogrp103NoeMorakhasi, StartTime: val.startTime, EndTime: val.endTime, Filepath: val.filePath, countDate: val.countDate, tarixTa: val.tarixTa, tarixAz: val.tarixAz }
      this.Flag = true
    },
    GetCombo(GRP) {
      let DataAxios_SetData = {
        ArryfildValue: { Id: GRP, Usergrp: null },
        Method: 'post',
        Action: 'TblCrmCombo/GetComboById',
      }
      this.$PostData(DataAxios_SetData).then((data) => {
        if (GRP == 102) {
          this.ListGrp102NoeDarkhast = data
        }
        if (GRP == 103) {
          this.ListGrp103NoeMorakhasi = data
        }
        return data
      })
    },
    GetCountLeveReq() {
      var Day = 0
      var Time = '00:00'
      this.Rows.forEach((e) => {
        if (e.countDate != null) {
          Day += e.countDate
        }
        if (e.countDate == null) {
          Time = this.$SumTime(Time, e.calcDateTime.split('ساعت')[0])
          let compare = this.$CompareTime('24:00', Time)
          if (compare != 0) {
            Time = compare
            Day++
          }
        }
      })
      return Day + ' روز ' + Time + ' ساعت | دقیقه '

      // console.log(countDate);
    },
    GetFullTimeRequest(lsitReq){
      console.log("😎 ~ GetFullTimeLeaveReq ~ lsitReq:", lsitReq)

      let Day=0;
      let Minutes="00:00";
     
        Day=0;
        Minutes="00:00"
        lsitReq.map((el)=>{
          if (el.countDate!=null) {
            Day+=el.countDate
          }
          else{
           let formattedTime= this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
            Minutes=this.$addTimes(Minutes, formattedTime.substring(0,5))
          }
        })
        return (Day + ' روز و ' + Minutes + ' ساعت ')
      
      // else if (lsitReq[0].tblFormAutomationId==2){
      //   Day=0;
      //   Minutes="00:00"
      //   lsitReq.map((el)=>{
      //     if (el.dayCount!=null) {
      //       Day+=el.dayCount
      //     }
      //     else{
      //      let formattedTime= this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
      //       Minutes=this.$addTimes(Minutes, formattedTime.substring(0,5))
      //     }
      //   })
      //   return (Day + ' روز و ' + Minutes + ' ساعت ')
      // }
      // else if (lsitReq[0].tblFormAutomationId==3){
      //   Day=0;
      //   Minutes="00:00"
      //   lsitReq.map((el)=>{
      //     if (el.dayCount!=null) {
      //       Day+=el.dayCount
      //     }
      //     else{
      //      let formattedTime= this.$ConvertTimeToStandardTime(this.$SubtractTime(el.startTime, el.endTime))
      //       Minutes=this.$addTimes(Minutes, formattedTime.substring(0,5))
      //     }
      //   })
      //   return (Day + ' روز و ' + Minutes + ' ساعت ')
      // }
      // else if (lsitReq[0].tblFormAutomationId==5){
      //   Day=0;
      //   Minutes="00:00"
      //   lsitReq.map((el)=>{
      //     Day+=el.amount
      //   })
      //   return (this.$Comma3ragham(Day) + ' ریال ')
      // }
      // else if (lsitReq[0].tblFormAutomationId==6){
      //   Day=0;
      //   Minutes="00:00"
      //   lsitReq.map((el)=>{
      //     Day+=el.amount
      //   })
      //   return (this.$Comma3ragham(Day) + ' ریال ')
      // }
      
    },
    GetFormAutomationId(){
      this.$FindTableNameOnAutomationCartabl(1).then((res) => {
             this.ControlName= res
            })
    }
  },
  created() {
    this.GetFormAutomationId()
    let a = this.$GetJalaliDate().split('/')
    a[2] = '01'
    this.Filter.tarixAz = a[0] + '/' + a[1] + '/' + a[2]
    const currentDate = moment()
    const lastDayOfMonth = currentDate.endOf('jMonth')
    this.Filter.tarixTa = lastDayOfMonth.format('jYYYY/jMM/jDD')

    this.GetListLeave()
    this.GetCombo(102)
    this.GetCombo(103)
    if (this.rowForEdit) {
      this.$store.state.OldDataForLog = this.rowForEdit
      this.Flag=true
      let row = JSON.parse(this.rowForEdit)
      this.Add = -1
      this.DataAxios = {
        Id: row.id,
        tblCombogrp102NoeDarkhast: row.tblCombogrp102NoeDarkhast,
        tblcombogrp103NoeMorakhasi: row.tblcombogrp103NoeMorakhasi,
        StartTime: row.startTime,
        EndTime: row.endTime,
        Filepath: row.filePath,
        countDate: row.countDate,
        tarixTa: row.tarixTa,
        tarixAz: row.tarixAz,
        dateTimeInsert: row.dateTimeInsert,
        tblUserGrpIdInsert: row.tblUserGrpIdInsert,
      }
    }
  },
  props: ['rowForEdit'],
}
</script>
<style scoped>
.Detail {
  color: var(--sidebar-color-item) !important;
  background-color: var(--table-background) !important;
  border-radius: 5px;
}
</style>
